/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";

import { TextField, MenuItem, Typography, Switch } from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import ReactSelect from "react-select";
import { Section } from "components/Section/Section";
import { getAltLabel } from "utils/getAltLabel";

/*  Este componente contém **exatamente** o layout “hard-coded” que você
    já utilizava antes de introduzir o stageLayout.  
    Ele recebe TODAS as props necessárias a partir de NewInitiativeForm. */
export default function LegacyInitialInfo({
  /* ───────── props vindas do parent ───────── */
  t,
  i18n,
  classes,
  clientColor,

  /* estado + handlers */
  formData,
  handleInputChange,
  formErrors,
  /* listas & opções */
  branches,
  workfronts,
  userOptions,
  customFields,
  tagOptions,
  impactOptions,
  accessOptions,
  /* selects controlados */
  selectedTags,
  setSelectedTags,
  selectedImpact,
  setSelectedImpact,
  selectedAccessGroups,
  setSelectedAccessGroups,
  /* misc */
  userDetails,
  renderCustomFields,
  selectedUsersInitiative,
  setSelectedUsersInitiative,
  selectedUsersImp,
  setSelectedUsersImp,
  selectedUsersResults,
  setSelectedUsersResults,
}) {
  /* estilos do React-Select (o mesmo que você usava) */
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "80px",
      maxHeight: "80px",
      overflowY: "auto",
      outline: "none",
      boxSizing: "border-box",
      borderColor: state.isFocused ? clientColor : provided.borderColor,
      backgroundColor: "white",
      boxShadow: state.isFocused ? `0 0 0 1px ${clientColor}` : "none",
      "&:hover": { borderColor: clientColor },
    }),
    menu: (p) => ({ ...p, overflowY: "auto" }),
    option: (p, state) => ({
      ...p,
      color: state.isSelected ? "black" : state.isFocused ? "white" : "black",
      backgroundColor: state.isSelected
        ? "gray"
        : state.isFocused
          ? clientColor
          : "white",
    }),
    multiValue: (p) => ({ ...p, backgroundColor: "#d3d3d3" }),
    multiValueLabel: (p) => ({ ...p, color: "black" }),
    multiValueRemove: (p) => ({
      ...p,
      color: "black",
      ":hover": { backgroundColor: "red", color: "white" },
    }),
  };

  /* ─────────────────────────────────────────────────────────────── */
  return (
    <GridContainer spacing={3} style={{ marginTop: 20 }}>
      {/* Ⅰ. IDENTIFICAÇÃO ------------------------------------------- */}
      <Section
        title={t("initiative_selected.section_identification")}
        clientColor={clientColor}
      >
        {/* Initiative Id */}
        <GridItem xs={12} sm={2} style={{ marginBottom: 20 }}>
          <TextField
            fullWidth
            label={t("new_initiatives.fields.initiative_id")}
            name="initiativeId"
            value={formData.initiativeId}
            onChange={handleInputChange}
            classes={{ root: classes.textFieldRoot }}
            InputProps={{ classes: { input: classes.inputText } }}
            InputLabelProps={{ classes: { root: classes.labelText } }}
          />
        </GridItem>

        {/* Initiative Name */}
        <GridItem xs={12} sm={10} style={{ marginBottom: 20 }}>
          <TextField
            fullWidth
            label={t("new_initiatives.fields.initiative_name")}
            name="initiativeName"
            value={formData.initiativeName}
            error={!!formErrors.initiativeName}
            onChange={handleInputChange}
            classes={{ root: classes.textFieldRoot }}
            InputProps={{ classes: { input: classes.inputText } }}
            InputLabelProps={{ classes: { root: classes.labelText } }}
          />
        </GridItem>

        {/* Branch */}
        <GridItem xs={12} sm={6} style={{ marginBottom: 14 }}>
          <TextField
            select
            fullWidth
            label={getAltLabel("new_initiatives.fields.branch", userDetails, t)}
            name="branch"
            value={formData.branch}
            error={!!formErrors.branch}
            onChange={handleInputChange}
            classes={{ root: classes.textFieldRoot }}
            InputProps={{ classes: { input: classes.inputText } }}
            InputLabelProps={{ classes: { root: classes.labelText } }}
          >
            {branches.map((b) => (
              <MenuItem
                key={b.name}
                value={b.name}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected,
                }}
              >
                {b.name}
              </MenuItem>
            ))}
          </TextField>

          {formData.branch &&
            branches.find((b) => b.name === formData.branch)?.leader && (
              <Typography variant="body2" className={classes.labelLeaders}>
                {`${t("new_initiatives.fields.branch_leader")}: ${
                  branches.find((b) => b.name === formData.branch).leader
                }`}
              </Typography>
            )}
        </GridItem>

        {/* Workfront */}
        <GridItem xs={12} sm={6} style={{ marginBottom: 14 }}>
          <TextField
            select
            fullWidth
            label={getAltLabel(
              "new_initiatives.fields.workfront",
              userDetails,
              t
            )}
            name="workfront"
            value={formData.workfront}
            error={!!formErrors.workfront}
            onChange={handleInputChange}
            classes={{ root: classes.textFieldRoot }}
            InputProps={{ classes: { input: classes.inputText } }}
            InputLabelProps={{ classes: { root: classes.labelText } }}
          >
            {workfronts.map((wf) => (
              <MenuItem
                key={wf.name}
                value={wf.name}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected,
                }}
              >
                {wf.name}
              </MenuItem>
            ))}
          </TextField>

          {formData.workfront &&
            workfronts.find((w) => w.name === formData.workfront)?.leader && (
              <Typography variant="body2" className={classes.labelLeaders}>
                {`${t("new_initiatives.fields.workfront_leader")}: ${
                  workfronts.find((w) => w.name === formData.workfront)
                    ?.leader || ""
                }`}
              </Typography>
            )}
        </GridItem>

        {/* Leader */}
        <GridItem xs={12} sm={4}>
          <TextField
            select
            fullWidth
            label={t("new_initiatives.fields.initiative_leader")}
            name="initiativeLeader"
            value={formData.initiativeLeader}
            error={!!formErrors.initiativeLeader}
            onChange={handleInputChange}
            classes={{ root: classes.textFieldRoot }}
            InputProps={{ classes: { input: classes.inputText } }}
            InputLabelProps={{ classes: { root: classes.labelText } }}
          >
            <MenuItem
              key="empty"
              value=""
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }}
            >
              {t("new_initiatives.fields.no_leader_selected", "-- Sem líder selecionado --")}
            </MenuItem>
            {userOptions.map((u) => (
              <MenuItem
                key={u.value}
                value={u.value}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected,
                }}
              >
                {u.label}
              </MenuItem>
            ))}
          </TextField>
        </GridItem>

        {/* Leader 2 */}
        <GridItem xs={12} sm={4}>
          <TextField
            select
            fullWidth
            label={t("new_initiatives.fields.initiative_leader_2")}
            name="initiativeLeader2"
            value={formData.initiativeLeader2}
            error={!!formErrors.initiativeLeader2}
            onChange={handleInputChange}
            classes={{ root: classes.textFieldRoot }}
            InputProps={{ classes: { input: classes.inputText } }}
            InputLabelProps={{ classes: { root: classes.labelText } }}
          >
            <MenuItem
              key="empty"
              value=""
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }}
            >
              {t("new_initiatives.fields.no_leader_selected", "-- Sem líder selecionado --")}
            </MenuItem>
            {userOptions.map((u) => (
              <MenuItem
                key={u.value}
                value={u.value}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected,
                }}
              >
                {u.label}
              </MenuItem>
            ))}
          </TextField>
        </GridItem>

        {/* PMO */}
        <GridItem xs={12} sm={4}>
          <TextField
            select
            fullWidth
            label={t("new_initiatives.fields.initiative_pmo")}
            name="initiativePmo"
            value={formData.initiativePmo}
            error={!!formErrors.initiativePmo}
            onChange={handleInputChange}
            classes={{ root: classes.textFieldRoot }}
            InputProps={{ classes: { input: classes.inputText } }}
            InputLabelProps={{ classes: { root: classes.labelText } }}
          >
            <MenuItem
              key="empty"
              value=""
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }}
            >
              {t("new_initiatives.fields.no_pmo_selected", "-- Sem PMO selecionado --")}
            </MenuItem>
            {userOptions.map((u) => (
              <MenuItem
                key={u.value}
                value={u.value}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected,
                }}
              >
                {u.label}
              </MenuItem>
            ))}
          </TextField>
        </GridItem>
      </Section>

      {/* Ⅱ. DATAS -------------------------------------------------------- */}
      <Section
        title={t("initiative_selected.section_dates")}
        clientColor={clientColor}
      >
        {[
          {
            key: "impStartDate",
            label: "imp_start_date",
            errorKey: "impStartDate",
          },
          {
            key: "impEndDate",
            label: "imp_end_date",
            errorKey: "impEndDate",
          },
          {
            key: "resultsStartDate",
            label: "results_start_date",
            errorKey: "resultsStartDate",
          },
          {
            key: "resultsEndDate",
            label: "results_end_date",
            errorKey: "resultsEndDate",
          },
        ].map(({ key, label, errorKey }) => (
          <GridItem xs={12} md={3} key={key}>
            <TextField
              type="date"
              label={t(`new_initiatives.fields.${label}`)}
              name={key}
              value={formData[key]}
              error={!!formErrors[errorKey]}
              helperText={formErrors[errorKey] || ""}
              onChange={handleInputChange}
              classes={{ root: classes.textFieldRoot }}
              InputProps={{ classes: { input: classes.inputText } }}
              InputLabelProps={{
                classes: { root: classes.labelText },
                shrink: true,
              }}
              style={{ width: "100%" }}
            />
          </GridItem>
        ))}
      </Section>

      {/* Ⅲ. DESCRIÇÃO & RISCOS ------------------------------------------ */}
      <Section
        title={t("initiative_selected.section_description")}
        clientColor={clientColor}
      >
        <GridItem xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label={t("new_initiatives.fields.description")}
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            classes={{ root: classes.textFieldRoot }}
            InputProps={{ classes: { input: classes.inputText } }}
            InputLabelProps={{
              classes: { root: classes.labelText },
              shrink: true,
            }}
          />
        </GridItem>

        {userDetails.has_forms_risks && (
          <GridItem xs={12}>
            <TextField
              fullWidth
              multiline
              rows={4}
              label={t("new_initiatives.fields.risks")}
              name="risks"
              value={formData.risks}
              onChange={handleInputChange}
              classes={{ root: classes.textFieldRoot }}
              InputProps={{ classes: { input: classes.inputText } }}
              InputLabelProps={{
                classes: { root: classes.labelText },
                shrink: true,
              }}
            />
          </GridItem>
        )}
      </Section>

      {/* Ⅳ. CAMPOS PERSONALIZADOS --------------------------------------- */}
      {customFields.length > 0 && (
        <Section
          title={t("initiative_selected.section_custom_fields")}
          clientColor={clientColor}
        >
          {renderCustomFields()}
        </Section>
      )}

      {/* Ⅴ. CLASSIFICAÇÃO ---------------------------------------------- */}
      <Section
        title={t("initiative_selected.section_classification")}
        clientColor={clientColor}
      >
        {userDetails.has_forms_impact && (
          <GridItem xs={12} md={6}>
            <div className={classes.multiSelectContainer}>
              <label
                className={classes.labelMultiSelect}
                style={{ marginBottom: 8 }}
              >
                {t("new_initiatives.fields.initiative_impact")}
              </label>
              <ReactSelect
                isMulti
                options={impactOptions}
                value={selectedImpact}
                onChange={setSelectedImpact}
                styles={customStyles}
                placeholder={t("new_initiatives.fields.select_label")}
                closeMenuOnSelect={false}
              />
            </div>
          </GridItem>
        )}

        <GridItem xs={12} md={6}>
          <div className={classes.multiSelectContainer}>
            <label
              className={classes.labelMultiSelect}
              style={{ marginBottom: 8 }}
            >
              {getAltLabel("new_initiatives.fields.tags", userDetails, t)}
            </label>
            <ReactSelect
              isMulti
              options={tagOptions}
              value={selectedTags}
              onChange={setSelectedTags}
              styles={customStyles}
              placeholder={t("new_initiatives.fields.select_label")}
              closeMenuOnSelect={false}
            />
          </div>
        </GridItem>

        <GridItem xs={12} md={6}>
          <div className={classes.multiSelectContainer}>
            <label
              className={classes.labelMultiSelect}
              style={{ marginBottom: 8 }}
            >
              {t("new_initiatives.fields.access_group")}
              {formErrors.accessGroup && (
                <span style={{ color: "red", fontSize: 12 }}>
                  {formErrors.accessGroup}
                </span>
              )}
            </label>
            <ReactSelect
              isMulti
              options={accessOptions}
              value={selectedAccessGroups}
              onChange={setSelectedAccessGroups}
              styles={customStyles}
              placeholder={t("new_initiatives.fields.select_label")}
              closeMenuOnSelect={false}
            />
          </div>
        </GridItem>
      </Section>

      {/* Ⅵ. EDITORES ---------------------------------------------------- */}
      {userDetails.has_forms_editors && (
        <Section
          title={t("initiative_selected.section_editors")}
          clientColor={clientColor}
        >
          {[
            {
              key: "one_page",
              value: selectedUsersInitiative,
              setter: setSelectedUsersInitiative,
              label: "editors_one_page",
            },
            {
              key: "implementation",
              value: selectedUsersImp,
              setter: setSelectedUsersImp,
              label: "editors_imp",
            },
            {
              key: "results",
              value: selectedUsersResults,
              setter: setSelectedUsersResults,
              label: "editors_results",
            },
          ].map(({ key, value, setter, label }) => (
            <GridItem xs={12} md={6} key={key}>
              <div className={classes.multiSelectContainer}>
                <label
                  className={classes.labelMultiSelect}
                  style={{ marginBottom: 8 }}
                >
                  {t(`new_initiatives.fields.${label}`)}
                </label>
                <ReactSelect
                  isMulti
                  options={userOptions}
                  value={value}
                  onChange={setter}
                  styles={customStyles}
                  placeholder={t("new_initiatives.fields.select_label")}
                  closeMenuOnSelect={false}
                />
              </div>
            </GridItem>
          ))}
        </Section>
      )}
    </GridContainer>
  );
}

/* ───────────── tipagem opcional ───────────── */
LegacyInitialInfo.propTypes = {
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  clientColor: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  formErrors: PropTypes.object.isRequired,
  branches: PropTypes.array.isRequired,
  workfronts: PropTypes.array.isRequired,
  userOptions: PropTypes.array.isRequired,
  customFields: PropTypes.array.isRequired,
  tagOptions: PropTypes.array.isRequired,
  impactOptions: PropTypes.array.isRequired,
  accessOptions: PropTypes.array.isRequired,
  selectedTags: PropTypes.array.isRequired,
  setSelectedTags: PropTypes.func.isRequired,
  selectedImpact: PropTypes.array.isRequired,
  setSelectedImpact: PropTypes.func.isRequired,
  selectedAccessGroups: PropTypes.array.isRequired,
  setSelectedAccessGroups: PropTypes.func.isRequired,
  renderCustomFields: PropTypes.func.isRequired,
  userDetails: PropTypes.object.isRequired,
  selectedUsersInitiative: PropTypes.array.isRequired,
  setSelectedUsersInitiative: PropTypes.func.isRequired,
  selectedUsersImp: PropTypes.array.isRequired,
  setSelectedUsersImp: PropTypes.func.isRequired,
  selectedUsersResults: PropTypes.array.isRequired,
  setSelectedUsersResults: PropTypes.func.isRequired,
};
